import React from 'react';

export default function MgyComponent({tpl: Template, className, children, ...rest}) {

    if (typeof Template === 'undefined')
        Template = (props) => <div {...props}/>

    return (
        <Template className={"mgy-component " + (className || '') } {...rest}>
            { children }
        </Template>
    );
};
